import EnglishIcon from "./../assets/svg/english.svg";
import CalendarIcon from "./../assets/svg/calendar.svg";
import CreativityIcon from "./../assets/svg/creativity.svg";
import OrderIcon from "./../assets/svg/order.svg";
import FacebookIcon from "./../assets/svg/facebook_author.svg";
import WWWIcon from "./../assets/svg/www_author.svg";
import MonikaJPG from "./../assets/img/authors/Monika.jpg";
import AniaJPG from "./../assets/img/authors/Anna.jpg";
import MarlenaJPG from "./../assets/img/authors/Marlena.jpg";
import AgnieszkaJPG from "./../assets/img/authors/Agnieszka.jpg";
import RenataJPG from "./../assets/img/authors/Renata.jpg";
import KarolinaJPG from "./../assets/img/authors/Karolina.jpg";
import one from "./../assets/img/planner_bowel/01.png";
import two from "./../assets/img/planner_bowel/02.png";
import three from "./../assets/img/planner_bowel/03.png";
import four from "./../assets/img/planner_bowel/04.png";
import five from "./../assets/img/planner_bowel/05.png";
import six from "./../assets/img/planner_bowel/06.png";
import seven from "./../assets/img/planner_bowel/07.png";
import eight from "./../assets/img/planner_bowel/08.png";

export const boxesPL = [
    {
        header: "English",
        description:
            "Stworzony w pełni po angielsku i dedykowany  nauczycielom angielskiego",
        icon: EnglishIcon,
    },
    {
        header: "Cały rok",
        description:
            "… a nawet 13 miesięcy, kalendarz od sierpnia 2021 do sierpnia 2022",
        icon: CalendarIcon,
    },
    {
        header: "Kreatywność",
        description:
            "Pomysły na zajęcia językowe dla przedszkolaków i dzieci wczesnoszkolnych",
        icon: CreativityIcon,
    },
    {
        header: "Organizacja",
        description:
            "Wszystko w jednym miejscu – kalendarz i planner w pracy nauczyciela",
        icon: OrderIcon,
    },
];

export const situationsPL = [
    {
        header: "Potrzebujesz wsparcia w rozplanowaniu tematów zajęć na poszczególne tygodnie?",
        description:
            "Easy! W plannerze znajdziesz gotowy rozkład materiału na cały rok, dodaliśmy: cele zajęć, proponowane piosenki, podstawowe słownictwo i zwroty, dodatkowe słownictwo i wyrażenia, proponowane aktywności i zabawy. ",
        inverted: false,
    },
    {
        header: "Znowu niedziela i znowu zastanawiasz się, co zaplanować, aby zaskoczyć uczniów?",
        description:
            "Otwórz kalendarz i skorzystaj z gotowych wskazówek i pomysłów! Naprawdę wystarczy przeczytać i można działać!",
        inverted: true,
    },
    {
        header: "Kolejny raz poszukujesz fajnej rymowanki?",
        description: "Sprawdź w kalendarzu, na pewno ją tam znajdziesz!",
        inverted: true,
    },
    {
        header: "Jesteś kreatywna, ale czasami brakuje Ci czasu albo ochoty na wymyślanie nowych zabaw? ",
        description:
            "Skorzystaj z gotowców, w Get Creative Every Day są pomysły na każdy tydzień w roku!",
        inverted: false,
    },
    {
        header: "Szukasz okazji do świętowania z uczniami?",
        description:
            "W każdym miesiącu znajdziesz listę świąt oficjalnych i nietypowych, które będą super okazją do przeprowadzenia ciekawych zajęć!",
        inverted: false,
    },
    {
        header: "Prowadzisz kilka grup, a listy z informacjami o uczniach masz w kilku miejscach? Rozkłady zajęć dla wszystkich grup też masz w kilku notesach? Nosisz to wszystko ze sobą codziennie?",
        description:
            "Wiemy, że lubisz shopper bags, ale po co zabierać miejsce pomocom dydaktycznym na rzecz kilku notesów? Weź tylko planner i miej wszystko w jednym miejscu!",
        inverted: true,
    },
    {
        header: "Korzystasz z dwóch albo więcej kalendarzy, żeby pomieścić notatki zawodowe i osobiste?",
        description:
            "W Get Creative pomieścisz wszystko, bo jest bardzo pojemny!",
        inverted: false,
    },
];

export const detailsBoxesPL = [
    {
        header: "School Year Calendar ",
        description:
            "Kalendarz na rok szkolny zawierający zakres od sierpnia do sierpnia (kalendarz krótki i długi z miejscem na notatki)",
    },
    {
        header: "Let’s plan",
        description:
            "Gotowy rozkład tematów na cały rok i miejsce do wpisania swoich notatek",
    },
    {
        header: "My students",
        description:
            "Praktyczne tabele do zapisywania dowolnych informacji o uczniach z każdej grupy, którą prowadzisz (10 tabel dla 10 grup)",
    },
    {
        header: "Contacts",
        description:
            "Wygodna tabela do zapisywania kontaktów, z których będziesz korzystać przez cały rok",
    },
    {
        header: "Tips – wskazówki dla nauczycieli, które przydadzą się w codziennej pracy",
        sublist: [
            { item: "5 niezawodnych energizerów" },
            { item: "5 wskazówek, jak zachęcić uczniów do mówienia" },
            {
                item: "5 sposobów na ćwiczenie uważności, które wspierają naukę angielskiego",
            },
            {
                item: "6 tipów na start – jak oszczędzać nauczycielski czas i wykorzystać każdą minutę",
            },
            {
                item: "Top 10 anglojęzycznych książeczek dla dzieci z efektem WOW",
            },
            {
                item: "Top 5 edukacyjnych stron internetowych dla dzieci, które uatrakcyjnią zajęcia",
            },
            {
                item: "Lista ciekawych filmów i seriali anglojęzycznych dla dzieci",
            },
        ],
    },
    {
        header: "Gotowy rozkład materiału",
        description:
            "Na każdy miesiąc wraz z: celami zajęć, przykładowymi piosenkami, podstawowym słownictwem i zwrotami, dodatkowym słownictwem i wyrażeniami, przykładowymi aktywnościami i zabawami (aż 60 gotowych aktywności!)",
    },
    {
        header: "Nursery rhymes",
        description:
            "20 tematycznych rymowanek, które uwielbiają młodsze dzieci",
    },
    {
        header: "Kreatywne zabawy na każdy tydzień roku ",
        description: "Aż 58 pomysłów do wykorzystania „od ręki”",
    },
    {
        header: "Let’s celebrate ",
        description: "Lista świąt oficjalnych i nietypowych na każdy miesiąc",
    },
    {
        header: "Terminarz",
        description:
            "Terminarz w układzie tygodniowym, dzięki któremu zaplanujesz pracę na każdy dzień",
    },
    {
        header: "Gotowy kalendarz",
        description:
            "Craft do wycięcia i pokolorowania z dziećmi – wspaniały pretekst do omówienia pór roku i wspólnej zabawy integrującej grupę",
    },
    { header: "Notatki", description: "Dużo miejsca na notatki" },
];

export const slidesPL = [
    {
        title: "School Year Calendar",
        description:
            "Kalendarz na rok szkolny zawierający zakres od sierpnia 2021 do sierpnia 2022 (kalendarz krótki i długi z miejscem na notatki)",
        photo: one,
    },
    {
        title: "Let’s plan",
        description:
            "Gotowy rozkład tematów na cały rok i miejsce do wpisania swoich notatek",
        photo: two,
    },
    {
        title: "My students",
        description:
            "Praktyczne tabele do zapisywania dowolnych informacji o uczniach z każdej grupy, którą prowadzisz (10 tabel dla 10 grup) ",
        photo: three,
    },
    {
        title: "Tips, Nursery rhymes, Let’s celebrate",
        list: [
            {
                item: "Wskazówki dla nauczycieli, które przydadzą się w codziennej pracy",
            },
            { item: "Aż 20 tematycznych rymowanek" },
            {
                item: "Lista świąt oficjalnych i nietypowych na każdy miesiąc",
            },
        ],
        photo: four,
    },
    {
        title: "Gotowy rozkład materiału",
        description:
            "Rozkład na każdy miesiąc wraz z: celami zajęć, przykładowymi piosenkami, podstawowym słownictwem i zwrotami, dodatkowym słownictwem i wyrażeniami, przykładowymi aktywnościami i zabawami (aż 60 gotowych aktywności)",
        photo: five,
    },
    {
        title: "Terminarz w układzie tygodniowym",
        description:
            "Terminarz, dzięki któremu zaplanujesz pracę na każdy dzień. Kreatywne zabawy na każdy tydzień roku (aż 58 pomysłów do wykorzystania „od ręki”)",
        photo: six,
    },
    { title: "Notatki", description: "Dużo miejsca na notatki", photo: seven },
    {
        title: "Kalendarz–craft",
        description:
            "Wspaniały pretekst do omówienia pór roku i wspólnej zabawy integrującej grupę",
        photo: eight,
    },
];

export const buyHeadersPL = [
    {
        header: "Widzisz?",
        description:
            "To nie tylko kalendarz i planner, ale po prostu niezbędnik nauczyciela angielskiego z wartościowymi materiałami, z których będziesz korzystać przez cały rok!",
    },
    {
        header: "Spiesz się! - Dlaczego warto kupić już teraz?",
        description:
            "Mimo, że do nowego roku szkolnego jeszcze kawał czasu, nigdy nie wiesz, kiedy nasze zapasy się skończą, my też nie. Nie trać wakacji na planowanie zajęć i wejdź  w nowy rok szkolny na pełnym luzie",
    },
    {
        header: "Dołącz do zorganizowanych i kreatywnych nauczycieli angielskiego",
        description:
            "Zorganizuj się za niewielkie pieniądze, to tylko 99 zł na cały rok! Czyli 8 zł miesięcznie, mniej niż mała latte!",
    },
];

export const authorsPL = [
    {
        photo: MonikaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Anna Kowalska",
            description:
                "Nauczycielka angielskiego z 18-letnim doświadczeniem w Polsce, Anglii i Irlandii, dyrektor studiów i trenerka nauczycieli. Wspiera zespoły dydaktyczne w szkołach językowych, szkoli nauczycieli i występuje na konferencjach i spotkaniach branżowych. Autorka strony That is Evil skierowanej do nauczycieli EFL.",
        },
    },
    {
        photo: AniaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Martyna Bornicka",
            description:
                "Nauczycielka angielskiego w przedszkolu. Zakochana w książkach dla dzieci, dla której opowiadanie historii jest ulubionym elementem zajęć. Założycielka Little Forest Children's Bookshop, miejsca pełnego kreatywnych pomocy dydaktycznych dla nauczycieli.",
        },
    },
    {
        photo: MarlenaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Cristine John",
            description:
                "Nauczycielka angielskiego od ponad 9 lat. Autorka bloga angielskiego. Jej filozofia edukacji zawsze polegała na tym, by nauka była ekscytująca, interesująca i zabawna.",
        },
    },
    {
        photo: KarolinaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Karolina Machnicka",
            description:
                "Nauczycielka angielskiego, która uwielbia pracować z dziećmi. Często wykorzystuje nietypowe pomoce dydaktyczne i książki anglojęzyczne na swoich lekcjach. Na co dzień dzieli się swoimi pomysłami i udostępnia materiały na blogu.",
        },
    },
    {
        photo: RenataJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Renata Nowak",
            description:
                "Magister filologii angielskiej, nauczycielka z ponad 10-letnim doświadczeniem. Autorka bloga 'EasyPeasy' i przewodnika 'Angielski bez podręcznika'. Konsultantka metodyczna, która wspierała tworzenie robota edukacyjnego na Uniwersytecie Dino.",
        },
    },
    {
        photo: AgnieszkaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Agnieszka Roland",
            description:
                "Tworzy gry językowe, w które sama chciałaby grać, przygotowuje lekcje, w których sama chciałaby uczestniczyć, uczy w sposób, w jaki sama chciałaby być nauczana. Pomaga innym nauczycielom uatrakcyjniać i ożywiać zajęcia językowe. Tworzy oryginalne gry, którymi chętnie dzieli się z nauczycielami różnych języków na stronie internetowej. Pokazuje, jak wykorzystywać technologię w klasie i uczy innych, jak uczyć, aby dobrze się bawić na własnych lekcjach. Sprawia, że zarówno nauczyciele, jak i uczniowie chcą się uczyć.",
        },
    },
];
